import { useQuery } from '@tanstack/react-query'

import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { usePermissions } from '../../auth/hooks/usePermissions'
import { ProjectSource } from '../../auth/lib/auth.types'
import { useSelectedProject } from '../../main/hooks/useSelectedProject'
import { FinanceService } from '../lib/finance.service'

const PERSONAL_ACCOUNTS = 'personal-accounts'

export const usePersonalAccounts = () => {
  const { selectedProjectId } = useSelectedProjectStore()
  const { selectedProject } = useSelectedProject()
  const permissions = usePermissions()

  const { data, isLoading, isError, error } = useQuery({
    queryKey: [PERSONAL_ACCOUNTS, selectedProjectId],
    queryFn: () => FinanceService.getPersonalAccounts(selectedProjectId),
    enabled:
      Boolean(selectedProjectId) &&
      selectedProject?.src === ProjectSource.SC &&
      permissions.finances
  })
  return { data, isLoading, isError, error }
}
